export const AREAS = [
  { value: "GLO", label: "Garantia da Lei e da Ordem" },
  { value: "Fronteiras", label: "Fronteiras e Ilícitos Transnacionais" },
  { value: "SegurancaMaritima", label: "Segurança Marítima, Naval e Hidroviária" },
  { value: "InteligenciaDefesa", label: "Inteligência de Defesa" },
  { value: "ApoioInteragencias", label: "Apoio Interagências" },
  { value: "DefesaCivil", label: "Defesa Civil e Eventos Extremos" },
  { value: "GrandesEventos", label: "Grandes Eventos e Proteção" },
  { value: "Antiterrorismo", label: "Antiterrorismo" },
  { value: "IlicitosAmbientais", label: "Ilícitos Ambientais" },
];

export const CLASSIFICACOES = [
  { value: "TP", label: "Tendência de Peso" },
  { value: "IC", label: "Incerteza Crítica" },
  { value: "FPD", label: "Fato Pré-Determinado" },
  { value: "SI", label: "Surpresa Inevitável" },
  { value: "FPF", label: "Fato Portador de Futuro" },
  { value: "WildCard", label: "Coringa / Wild Card" },
  { value: "EA", label: "Principais Atores e suas Estratégias" },
];

export const PESTEL = [
  { value: "Politica", label: "Política" },
  { value: "Economica", label: "Econômica" },
  { value: "Social", label: "Social" },
  { value: "Tecnologica", label: "Tecnológica" },
  { value: "Ambiental", label: "Ambiental" },
  { value: "Legal", label: "Legal" },
];

export const RECORTES = [
  { value: "Mundo", label: "Mundo" },
  { value: "PaisEstrangeiro", label: "País Estrangeiro" },
  { value: "Brasil", label: "Brasil" },
  { value: "Regiao", label: "Região" },
  { value: "PaisEspecifico", label: "País Específico" },
  { value: "EstadoBR", label: "Estado Brasileiro" },
  { value: "Municipio", label: "Município" },
];

export const STATUS = [
  { value: "rascunho", label: "Rascunho", className: "badge-muted" },
  { value: "pendente", label: "Pendente", className: "badge-warn" },
  { value: "aprovado", label: "Aprovado", className: "badge-success" },
  { value: "rejeitado", label: "Rejeitado", className: "badge-danger" },
  { value: "arquivado", label: "Arquivado", className: "badge-muted" },
];

export const PERFIS = [
  { value: "admin", label: "Administrador Geral" },
  { value: "coordenador", label: "Coordenador" },
  { value: "pesquisador", label: "Pesquisador" },
  { value: "revisor", label: "Revisor" },
  { value: "visitante", label: "Visitante / Consulta" },
];

// MVP — somente Admin e Pesquisador são expostos nos seletores da UI.
// O backend continua aceitando os demais perfis (coordenador/revisor/visitante)
// para retrocompatibilidade, mas a interface simplifica a operação institucional.
export const PERFIS_MVP = PERFIS.filter((p) => p.value === "admin" || p.value === "pesquisador");

export const CHART_COLORS = ["#C5A028", "#38BDF8", "#818CF8", "#F472B6", "#34D399", "#94A3B8", "#F59E0B", "#A78BFA", "#FB7185"];

// ====== METODOLOGIA V2 — LSC/EGN ======

// Definições resumidas das 7 classificações (Manual V2)
export const CLASSIFICACAO_DEFINICOES = {
  TP: { titulo: "Tendência de Peso", desc: "Eventos cuja direção e sentido são suficientemente consolidados para admitir continuidade no futuro." },
  FPD: { titulo: "Fato Pré-Determinado", desc: "Eventos já conhecidos, cuja ocorrência é praticamente certa, mas que ainda não se efetivaram." },
  FPF: { titulo: "Fato Portador de Futuro", desc: "Sinais existentes no ambiente, pequenos no presente, mas com grandes consequências e potencialidades futuras." },
  IC: { titulo: "Incerteza Crítica", desc: "Eventos incertos e de grande importância para cenarização, capazes de determinar múltiplos futuros possíveis." },
  SI: { titulo: "Surpresa Inevitável", desc: "Forças previsíveis, já em operação, mas sem clareza de quando, como ou com quais consequências irão se configurar." },
  WildCard: { titulo: "Coringa / Wild Card", desc: "Grandes surpresas de baixa probabilidade e alto impacto, difíceis de antecipar e de rápida materialização." },
  EA: { titulo: "Principais Atores e suas Estratégias", desc: "Indivíduos, grupos ou organizações que influenciam ou recebem influência significativa do sistema." },
};

// Status de acesso à fonte
export const ACCESS_STATUS = [
  { value: "PENDENTE_VERIFICACAO", label: "Pendente de verificação", className: "badge-muted" },
  { value: "LINK_FUNCIONANDO", label: "Link funcionando", className: "badge-success" },
  { value: "LINK_QUEBRADO", label: "Link quebrado", className: "badge-danger" },
  { value: "SEM_LINK", label: "Sem link", className: "badge-warn" },
  { value: "BUSCAR_SCHOLAR", label: "Buscar no Google Acadêmico", className: "badge-info" },
  { value: "PDF_ANEXADO", label: "PDF anexado", className: "badge-success" },
  { value: "LINK_DRIVE_EXCEPCIONAL", label: "Link Drive excepcional", className: "badge-warn" },
  { value: "ACESSO_RESTRITO", label: "Acesso restrito", className: "badge-danger" },
];

// 8 etapas da Esteira Metodológica
export const ESTEIRA_ETAPAS = [
  { key: "identificacao_literatura", label: "Identificação da Literatura" },
  { key: "verificacao_acesso", label: "Verificação de Acesso" },
  { key: "leitura_analitica", label: "Leitura Analítica" },
  { key: "identificacao_insumos", label: "Identificação de Insumos" },
  { key: "registro_formulario", label: "Registro no Formulário" },
  { key: "upload_documento", label: "Upload do Documento" },
  { key: "link_drive_excepcional", label: "Link Drive Excepcional" },
  { key: "envio_revisao", label: "Envio para Revisão Humana" },
];

export const ESTEIRA_STATUS = {
  nao_iniciado: { label: "Não iniciado", color: "var(--text-muted)" },
  em_andamento: { label: "Em andamento", color: "var(--warn)" },
  concluido: { label: "Concluído", color: "var(--success)" },
  nao_aplicavel: { label: "Não aplicável", color: "var(--text-muted)" },
};

// Checklist Operacional do Pesquisador — 4 grupos
export const CHECKLIST_GROUPS = [
  {
    key: "documento",
    label: "Documento",
    items: [
      { key: "acessado", label: "Documento acessado" },
      { key: "link_verificado", label: "Link verificado" },
      { key: "salvo_pdf", label: "Documento salvo em PDF" },
    ],
  },
  {
    key: "analise",
    label: "Análise",
    items: [
      { key: "leitura_realizada", label: "Leitura realizada" },
      { key: "trecho_identificado", label: "Trecho relevante identificado" },
      { key: "citacao_copiada", label: "Citação direta copiada" },
    ],
  },
  {
    key: "registro",
    label: "Registro",
    items: [
      { key: "titulo_copiado", label: "Título copiado exatamente" },
      { key: "data_preenchida", label: "Data da fonte preenchida" },
      { key: "link_incluido", label: "Link da fonte incluído" },
    ],
  },
  {
    key: "classificacao",
    label: "Classificação",
    items: [
      { key: "instituicao_identificada", label: "Instituição identificada" },
      { key: "descricao_factual", label: "Descrição factual do fenômeno" },
      { key: "pestel_definida", label: "Dimensão PESTEL definida" },
      { key: "recorte_definido", label: "Recorte geográfico definido" },
    ],
  },
];

// Tipos de trecho (campo tipo_trecho)
export const TIPO_TRECHO = [
  "Parágrafo",
  "Conjunto de parágrafos",
  "Trecho de seção",
  "Até uma página",
];

// ─── Manual SFD 2026 — Linhas de Pesquisa ────────────────────────────
export const LINHAS_PESQUISA_SFD = [
  { value: "ameacas_eletromagneticas", label: "Ameaças Eletromagnéticas" },
  { value: "biodefesa_seguranca_alimentar", label: "Biodefesa e Segurança Alimentar" },
  { value: "escassez_recursos", label: "Escassez de Recursos" },
  { value: "energia_nuclear_futuro", label: "Energia Nuclear e Futuro" },
  { value: "desastres_futuros_defesa", label: "Desastres Futuros — Impactos em Defesa" },
  { value: "guerra_do_futuro", label: "Guerra do Futuro" },
  { value: "guerra_cognitiva", label: "Guerra Cognitiva" },
  { value: "meio_ambiente_maritimo", label: "Meio Ambiente Marítimo" },
  { value: "seguranca_espacial", label: "Segurança Espacial" },
  { value: "impacto_maritimo_naval", label: "Tendências de Impacto Marítimo-Naval" },
  { value: "seguranca_defesa_cibernetica", label: "Segurança e Defesa Cibernética" },
  { value: "inteligencia_artificial", label: "Inteligência Artificial" },
  { value: "iot_robotica", label: "Internet das Coisas e Robótica" },
  { value: "tecnologias_quanticas", label: "Tecnologias Quânticas" },
];

// Ferramentas de IA aceitas na declaração
export const AI_TOOLS = [
  "Gemini",
  "ChatGPT",
  "Claude",
  "Perplexity",
  "Emergent LLM",
  "Outros",
];

// Finalidades típicas do uso de IA
export const AI_PURPOSES = [
  "Extração de insumos",
  "Apoio à classificação",
  "Resumo",
  "Tradução",
  "Sugestão de palavras-chave",
  "Outros",
];

export function labelOf(list, v) {
  return list.find((x) => x.value === v)?.label || v || "—";
}
